import React, { useEffect, useState, createContext, useContext } from "react";
import { api } from "./api";

const DiscountContext = createContext({ discount: null });

export function DiscountProvider({ children }) {
    const [discount, setDiscount] = useState(null);
    useEffect(() => { api.get("/discounts/active").then(({ data }) => setDiscount(data)).catch(() => {}); }, []);
    return <DiscountContext.Provider value={{ discount, setDiscount }}>{children}</DiscountContext.Provider>;
}

export const useDiscount = () => useContext(DiscountContext);

export function computeDiscountedPrice(product, discount) {
    if (!discount || !discount.active) return { final: product.precio_venta, original: product.precio_venta, percent: 0 };
    // Site-wide discounts NEVER apply to vendor products — they only cover admin-posted products.
    if (product.vendedor_id) return { final: product.precio_venta, original: product.precio_venta, percent: 0 };
    const original = parseFloat(product.precio_venta || 0);
    // Check scope
    if (discount.scope === "categories") {
        const cats = discount.categories || [];
        if (cats.length > 0 && !cats.includes(product.categoria)) {
            return { final: original, original, percent: 0 };
        }
    }
    let final = original;
    let percent = 0;
    if (discount.type === "percent") {
        percent = Math.min(90, parseFloat(discount.value || 0));
        final = original * (1 - percent / 100);
    } else if (discount.type === "fixed") {
        final = Math.max(0, original - parseFloat(discount.value || 0));
        percent = original > 0 ? ((original - final) / original) * 100 : 0;
    }
    return { final: Number(final.toFixed(2)), original, percent: Math.round(percent) };
}
